import React, { useEffect, useState } from 'react'

export default function CountDown({ preTxt, second = 0, onDone = () => {} }) {
  const [seconds, setSeconds] = useState(second)

  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1)
      }, 1000)
      return () => clearInterval(interval)
    } else {
      onDone(true)
    }
  }, [seconds])

  return (
    <>
      {seconds > 0 && (
        <p style={{ fontSize: '1.1rem', color: seconds <= 15 ? '#fb8a81' : '#2da888' }}>
          <b>
            {`${preTxt ? preTxt + ' : ' : ''} ( ${Math.floor(seconds / 60)} :
                            ${(seconds % 60).toString().padStart(2, '0')} )`}
          </b>
        </p>
      )}
    </>
  )
}
